import React, { useState } from "react"

import { NotificationManager } from "react-notifications"
import { gql, useMutation } from "urql"

import { AcrClassPromptAnswerType } from "./types"

type NewPromptProps = {
  audioRoomId: string
}

const NewPrompt = ({ audioRoomId }: NewPromptProps) => {
  const [mutationState, runMutation]: any[] = useMutation(createPromptMutation)
  const [body, setBody] = useState("")
  const [answerType, setAnswerType] =
    useState<AcrClassPromptAnswerType>("yesNo")

  const submitPrompt = () => {
    runMutation({ audioRoomId, body: body.trim(), answerType })
      .then(result => {
        const { failures } = result.data.createAcrClassPrompt
        if (failures.length > 0) {
          NotificationManager.error(failures[0].message)
          return
        }

        setBody("")
      })
      .catch(() => NotificationManager.error("Unable to send question"))
  }

  return (
    <>
      <textarea
        value={body}
        maxLength={1000}
        rows={3}
        onChange={event => setBody(event.target.value)}
        className="w-full rounded-lg border border-solid border-neutral-600 bg-neutral-900 p-3 text-white"
        placeholder="Ask your students a question"
      />
      <div className="mt-3 flex flex-wrap items-center justify-between gap-3">
        <div className="flex gap-4 text-sm">
          <label className="flex items-center gap-2">
            <input
              type="radio"
              checked={answerType === "yesNo"}
              onChange={() => setAnswerType("yesNo")}
            />
            Yes / No
          </label>
          <label className="flex items-center gap-2">
            <input
              type="radio"
              checked={answerType === "freeResponse"}
              onChange={() => setAnswerType("freeResponse")}
            />
            Free response
          </label>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-xs text-neutral-400">{body.length}/1000</span>
          <button
            type="button"
            disabled={mutationState.fetching || body.trim().length === 0}
            onClick={submitPrompt}
            className="rounded-lg bg-sky-700 px-5 py-2 font-semibold text-white hover:bg-sky-600 disabled:opacity-60"
          >
            {mutationState.fetching ? "Sending..." : "Send"}
          </button>
        </div>
      </div>
    </>
  )
}

const createPromptMutation = gql`
  mutation CreateAcrClassPrompt(
    $audioRoomId: ID!
    $body: String!
    $answerType: AcrClassPromptAnswerTypeEnum!
  ) {
    createAcrClassPrompt(
      audioRoomId: $audioRoomId
      body: $body
      answerType: $answerType
    ) {
      failures {
        message
      }
    }
  }
`

export default NewPrompt
